// src/components/AuthorDetails.js
import React from 'react';
import distanceIcon from '../assets/ico-km-distancia.svg';
import phoneIcon from '../assets/ico-telefone-perfil.svg';
import H3 from './H3/H3';
import Avatar from './Avatar/Avatar';
import verifyIcon from '../assets/verify-icon.svg';
import useUserFeedback from '../hooks/useUserFeedback';

const AuthorDetails = ({ authorInfo, title }) => {
  const feedback = useUserFeedback(authorInfo?.id);

  if (!authorInfo) {
    return <div>Carregando...</div>;
  }

  const { firstName, lastName, avatar, about, mobile, address, verified, status, userType } = authorInfo;

  const statusBadge = (() => {
    if (status === 'em_pausa') {
      return <span className="ml-2 inline-block bg-yellow-100 text-yellow-800 text-[10px] font-semibold px-2 py-0.5 rounded-full">Em pausa</span>;
    }
    if (status === 'nao_disponivel') {
      return <span className="ml-2 inline-block bg-red-100 text-red-800 text-[10px] font-semibold px-2 py-0.5 rounded-full">Não disponível</span>;
    }
    // Sem status definido tratamos como ativo/disponível.
    return <span className="ml-2 inline-block bg-green-100 text-green-800 text-[10px] font-semibold px-2 py-0.5 rounded-full">Disponível</span>;
  })();

  const userTypeBadge = (() => {
    const map = {
      migrante_refugiado: { label: 'Migrante / Refugiado', className: 'bg-purple-100 text-purple-800' },
      representante_organizacao: { label: 'Representante de organização', className: 'bg-blue-100 text-blue-800' },
      apoiador: { label: 'Apoiador', className: 'bg-teal-100 text-teal-800' },
    };
    const info = map[userType];
    if (!info) return null;
    return (
      <span className={`inline-block ${info.className} text-[10px] font-semibold px-2 py-0.5 rounded-full`}>
        {info.label}
      </span>
    );
  })();

  return (
    <div className="flex flex-col md:p-4 pt-3 border border-t-1 border-l-0 border-r-0 border-b-0 md:border border-gray-300 md:rounded-xl bg-white max-w-md mx-auto">
      <H3 text={title} textColor="purple" />
      <div className="flex items-start -mt-4">
        <div className="shrink-0">
          <Avatar src={avatar} alt={`Avatar of ${firstName}`} name={firstName} large={false} />
        </div>
        <div className="flex flex-col ml-2">
          <div className="flex items-center flex-wrap"> {/* Add a div to contain both icon and name */}
            {verified && <img src={verifyIcon} alt="Verified" className="w-4 h-4 mr-1" />}
            <p className="text-sm font-bold text-gray-800">{firstName} {lastName}</p>
            {statusBadge}
          </div>
          {userTypeBadge && (
            <div className="mt-1">{userTypeBadge}</div>
          )}
          {address && (
            <div className="flex items-center mt-2">
              <img src={distanceIcon} alt="Distance" className="w-4 h-4 mr-1" />
              <p className="text-sm text-gray-500">{address.city} - {address.state}</p>
            </div>
          )}
        </div>
      </div>
      {feedback && !feedback.loading && feedback.count > 0 && (
        <div className="flex items-center mt-3" title={`Média de ${feedback.average.toFixed(1)} em ${feedback.count} avaliações`}>
          <span style={{ color: '#EE7913' }} className="text-base mr-1">★</span>
          <p className="text-sm text-gray-700 font-bold mr-1">
            {feedback.average.toFixed(1)}
          </p>
          <p className="text-xs text-gray-500">
            ({feedback.count} {feedback.count === 1 ? 'avaliação' : 'avaliações'})
          </p>
        </div>
      )}
      <p className="text-sm text-gray-500 mt-4 mb-0">{about}</p>
      {title !== "Perfil do empreendedor" && mobile && (
        <div className="flex items-center mt-4">
          <img src={phoneIcon} alt="Phone" className="w-5 h-5 mr-2" />
          <a href={`tel:${mobile}`} className="text-sm text-blue-700 font-bold hover:underline">{mobile}</a>
        </div>
      )}
    </div>
  );
};

export default AuthorDetails;
